import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Box, Button } from "grommet"
import { Copy } from "grommet-icons"
import { useToasts } from 'react-toast-notifications'
import envConfig from '../../utils/envConfig'

export const TTCopyClipboard = ({ copyText }) => {
    const { addToast } = useToasts()
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    return (
    <Box alignSelf="center" alignContent="center" align="center" justify="center" pad="xxsmall" round="small">
        {!liteMode &&
        <CopyToClipboard text={copyText}>
            <Button 
                plain 
                hoverIndicator={{ color: "dark-4", opacity: "medium" }} 
                icon={<Copy size="16px" color="dark-6" />}
                onClick={() => {
                    addToast("Copied to Clipboard", {
                        appearance: "success",
                        autoDismiss: true,
                    })
                }}
            />
        </CopyToClipboard>
        }
    </Box>
)}

export default TTCopyClipboard
